import { invokeFunction } from "@/lib/invoke";

/** Activity emails via Brevo (`send-activity-email`). Loan approval stays on Resend. */
export type ActivityEmailType =
  | "welcome"
  | "kyc_received"
  | "kyc_approved"
  | "kyc_rejected"
  | "tier_upgrade"
  | "loan_application_received"
  | "loan_declined"
  | "loan_disbursed"
  | "repayment_received"
  | "rollover"
  | "due_today"
  | "overdue"
  | "bank_account_changed";

/** Fire-and-forget — never blocks the main UX path. */
export function sendActivityEmail(
  type: ActivityEmailType,
  userId: string,
  vars: Record<string, string | number | undefined> = {},
): void {
  if (!userId) return;
  void invokeFunction("send-activity-email", {
    type,
    user_id: userId,
    vars,
  }).catch((e) => {
    console.error("send-activity-email", type, e);
  });
}
